import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { translations } from '../../../../locales/translations';
import { DisplayBooleanHorizontal } from './DisplayBooleanHorizontal';
import { DisplayFieldHorizontal } from './DisplayFieldHorizontal';
import { useSelector } from 'react-redux';
import { selectPreviewMode, selectOneOffView } from '../slice/selectors';
import { QuoteItemCard } from './QuoteItemCard';
import { Grid } from '@material-ui/core';
import { LoadingIndicator } from '../../../components/LoadingIndicator';
import { biType } from '../../../../locales/types';
import { selectContractStatus } from '../../WorkListPage/slice/selectors';

export function OneOffItems(props) {
  const { oneOffData } = props;
  const oneOffView = useSelector(selectOneOffView);
  const [displayData, setDisplayData] = useState(oneOffData);
  const [highlightChange, setHighlightChange] = useState(false);
  const previewMode = useSelector(selectPreviewMode);
  const contractStatus = useSelector(selectContractStatus);

  React.useEffect(() => {
    if (previewMode && oneOffView) {
      setHighlightChange(true);
      setDisplayData(oneOffView);
    } else {
      setDisplayData(oneOffData);
    }

    if(contractStatus![`oneOffStatus`] === 'Auto'){
      setHighlightChange(false);
    }
  }, [previewMode]);

  React.useEffect(() => {
    if (!previewMode) {
      setDisplayData(oneOffData);
    } else if (oneOffView) {
      setDisplayData(oneOffView);
    }
  }, [oneOffData]);

  return (
    <Wrapper>
      {displayData && oneOffData ? (
        <div>
          <Grid container className='header'>
            <Grid item xs={12} md={4}>
              <DisplayBooleanHorizontal
                value={displayData.invoiceFurtherNotice}
                label={translations.contractDetail.invoiceFurtherNotice}
                displayChange={highlightChange && displayData.invoiceFurtherNotice !== oneOffData.invoiceFurtherNotice}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DisplayFieldHorizontal
                label={translations.contractDetail.paymentTerms}
                value={displayData.paymentTerms}
                displayChange={highlightChange && displayData.paymentTerms !== oneOffData.paymentTerms}
              />
            </Grid>
          </Grid>
          {oneOffData.oneOffItems.map((item, index) => (
            <QuoteItemCard key={index} data={item}
                           viewChangeData={oneOffView ? oneOffView.oneOffItems[index] : null}
                           displayType={biType.ONEOFF} />
          ))}
          {previewMode && displayData.newItems && displayData.newItems.map((item, index) => (
            <QuoteItemCard key={'newItems'+index} data={item} isNewItem={true}
                           viewChangeData={null}
                           displayType={biType.ONEOFF} />
          ))}
        </div>
      ) : (
        <LoadingIndicator />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: ${p => p.theme.containerBackground};
  font-size: 12px;
  border-radius: 5px;

  .header {
    display: flex;
    margin-bottom: 5px;
  }
`;
